import useFetchAndTrace from "./hooks/fetchWithTrace";
import settings from "../constants/settings";
import { useCallback } from "react";
import { useCustomAlert } from "./hooks/alerts";
import { useGoogleReCaptcha } from "@google-recaptcha/react";

export function useSubmitContactForm() {
  const fetchAndTrace = useFetchAndTrace();
  const customAlert = useCustomAlert();
  const googleReCaptcha = useGoogleReCaptcha();

  return useCallback(
    async (
      phoneNumber: string,
      replyToEmail: string,
      subject: string,
      content: string,
      onSent: () => void,
      onError: () => void,
    ) => {
      if (!googleReCaptcha.executeV3) {
        return;
      }
      const token = await googleReCaptcha.executeV3("useSubmitContactForm");

      const contactFormHandler = async (response: Response) => {
        if (response.ok) {
          onSent();
        } else if (response.status == 400) {
          const { detail } = (await response.json()) as { detail: string };
          customAlert(detail);
          onError();
        } else {
          throw Error("Failed to submit contact form");
        }
      };

      const errorHandler = () => {
        customAlert(
          "We're sorry something went wrong. We will be looking into it!",
        );
        onError();
      };

      await fetchAndTrace(
        `${settings.api_url}/contact`,
        contactFormHandler,
        errorHandler,
        {
          body: JSON.stringify({
            phone_number: phoneNumber,
            reply_to_email: replyToEmail,
            subject,
            content,
            recaptcha_token: token,
          }),
          method: "POST",
        },
      );
    },
    [customAlert, fetchAndTrace, googleReCaptcha],
  );
}
